

















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { ShippingAddress } from '@/models/filebunker/shippingaddress';
import { Utils } from '@/helper/utils';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { shippingAddressService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class ShippingAddressListPage extends Base {
  public pagedShippingAddresses: ShippingAddress[] = [];
  public headers: VHeaders[] = [];
  public storeId: number;

  public pagination = new PaginationModel('name');
  public loading: boolean = false;
  public actions: any[] = [];
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('shippingAddress.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteAddress();
    },
  };
  public shippingAddressIdToDelete: number = 0;

  public searched: boolean = false;
  public deleted: boolean = false;
  public created() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = this.userSession.storeId;
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addShippingAddress') {
      this.$router.push({
        name: 'admin.shippingaddresses.add',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('shippingAddress.btnAddShippingAddress'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('shippingAddress.btnAddShippingAddress'),
      click: 'addShippingAddress',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'addressBook');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.setHeader();
    if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
      this.getShippingAddresses();
    }

    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-edit',
        title: this.$t(
          'shippingAddress.shippingAddressGridHeaders.gridAction.edit'
        ) as string,
        action: (model: ShippingAddress) => {
          return {
            name: 'admin.shippingaddresses.edit',
            params: {
              id: model.id,
              storeId: this.storeId,
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$t(
          'shippingAddress.shippingAddressGridHeaders.gridAction.delete'
        ) as string,
        color: 'error',
        action: (model: ShippingAddress) => {
          this.confirmDelete(Number(model.id));
        },
      },
    ];
  }

  public setHeader() {
    this.headers = [
      {
        align: 'left',
        sortable: true,
        text: this.$parent.$t(
          'shippingAddress.shippingAddressGridHeaders.name'
        ) as string,
        value: 'name',
      },
      {
        align: 'left',
        sortable: true,
        text: this.$parent.$t(
          'shippingAddress.shippingAddressGridHeaders.city'
        ) as string,
        value: 'city',
      },
      {
        align: 'left',
        sortable: true,
        text: this.$parent.$t(
          'shippingAddress.shippingAddressGridHeaders.state'
        ) as string,
        value: 'state',
      },
      {
        align: 'center',
        isNotDataProp: true,
        sortable: false,
        text: this.$parent.$t(
          'shippingAddress.shippingAddressGridHeaders.action'
        ) as string,
      },
    ];
  }

  public async getShippingAddresses(): Promise<void> {
    try {
      this.loading = true;
      const response = await shippingAddressService.getAll(
        this.pagination,
        Number(this.storeId)
      );
      this.pagedShippingAddresses = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
    }
  }
  public pageChanged(paging: any) {
    this.pagination = paging;
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
    this.getShippingAddresses();
  }

  public confirmDelete(id: number): void {
    this.deleteDialog.model = true;
    this.shippingAddressIdToDelete = id;
  }

  public async deleteAddress(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await shippingAddressService.deleteAddress(
        this.shippingAddressIdToDelete,
        this.storeId
      );
      this.deleted = true;
      this.showAlert(
        true,
        this.$t('shippingAddress.alertDeleteShippingAddress')
      );
      this.getShippingAddresses();
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.model = false;
    }
  }

  public changeStore(storeId: number): void {
    this.storeId = storeId;
    this.getShippingAddresses();
  }
}
